import { InputProps } from '@apia/theme';
import { Input } from '../../components';
import { ValidatedCollectorField } from '../ValidatedCollectorField';
import { getLabelName, getLabelTooltip } from '@apia/util';

export class CollectorInput extends ValidatedCollectorField<
  string,
  Omit<InputProps, 'name'>
> {
  type = 'input';

  Component = () => {
    const rules = this.useValidationRules();
    const validationFunction = this.useValidationFunction();
    const props = this.useProperties();

    return (
      <Input
        {...props}
        initialValue={this.config.initialValue}
        validationFunction={validationFunction}
        name={this.name}
        label={getLabelName(this.label)}
        title={getLabelTooltip(this.label)}
        validationRules={rules}
        avoidRegisterIfExists
      />
    );
  };
}
